// extracted by mini-css-extract-plugin
module.exports = {"password":"Company-password-1SOjc","checkboxLabel":"Company-checkboxLabel-1tF2-"};